import { UploadOutlined } from "@ant-design/icons";
import { Button, Card, Flex, Typography, Upload, message } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as Logo } from "../../../assets/Icons/sidebarlogo.svg";
import "./ChatBox.scss";
const { Text } = Typography;

const ChatBox = ({ onButtonClick, handleFileChange }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const { token, user } = useSelector((state) => state.auth);

  const handleButtonClick = (text) => {
    onButtonClick(text, selectedFile);
    setSelectedFile(null);
  };

  const uploadProps = {
    accept: ".csv",
    beforeUpload: (file) => {
      const isCSV = file.type === "text/csv" || file.name.endsWith(".csv");
      if (!isCSV) {
        message.error("You can only upload CSV files!");
        return false;
      }
      setSelectedFile(file);
      return false; 
    },
    onRemove: () => {
      setSelectedFile(null);
    },
    fileList: selectedFile ? [selectedFile] : [],
  };

  return (
    <Flex className="chatBoxMain">
      <Card className="middleContentWrapper">
        <Flex className="middleContent">
          <Flex className="logo_greeting_wrapper">
            <Flex className="logo_box">
              <Logo />
            </Flex>
            <Flex className="greeting_box">
              <Text className="text_font">Hi there, {user?.first_name
              }</Text>
              <Text className="text_font">What would you like to know?</Text>
            </Flex>
          </Flex>
          <Flex className="askAbout" vertical>
            <Text className="text_small">Ask About</Text>
            <div className="questionsBtn">
              <Button
                onClick={() => handleButtonClick("Target Vs Achievement")}
              >
                Target Vs Achievement
              </Button>
              <Button onClick={() => handleButtonClick("Recovery Projection")}>
                Recovery Projection
              </Button>
              <Button
                onClick={() => handleButtonClick("Trustwise Recovery Data")}
              >
                Trustwise Recovery Data
              </Button>
              <Button onClick={() => handleButtonClick("Allocation Numbers")}>
                Allocation Numbers
              </Button>
            </div>
            <Flex className="upload-section" vertical gap="small">
              <Text className="text_small">Upload CSV File</Text>
              <Upload {...uploadProps} onChange={({ fileList }) => {
                handleFileChange(fileList)
              }} maxCount={1}>
                <Button icon={<UploadOutlined />}>Select CSV File</Button>
              </Upload>
              {selectedFile && (
                <Button
                  type="primary"
                  onClick={() =>
                    handleButtonClick("Please analyze provided file")
                  }
                >
                  Analyze File
                </Button>
              )}
            </Flex>
          </Flex>
        </Flex>
      </Card>
    </Flex>
  );
};

export default ChatBox;
